<template>
  <div
    v-if="isShowScore"
    :class="[
      `as-score-vs as-score-vs__num as-score-vs__${size} as-score-vs-${siteName}`,
      {
        [`as-score-vs-${siteName}__home-win`]: homeScore > awayScore,
        [`as-score-vs-${siteName}__away-win`]: homeScore < awayScore,
        [`as-score-vs-${siteName}__draw`]: homeScore === awayScore,
        [`as-score-vs-${siteName}-${modifyClass}`]: modifyClass,
      },
    ]"
  >
    <span
      class="as-home-score"
      :class="{
        'as-winner': homeScore > awayScore,
      }"
    >
      {{ homeScore }}
    </span>
    <b>:</b>
    <span
      class="as-away-score"
      :class="{
        'as-winner': homeScore < awayScore,
      }"
    >
      {{ awayScore }}
    </span>
  </div>
  <span
    v-else
    :class="`as-score-vs as-score-vs__${size} as-score-vs__only-text as-score-vs__only-text-${siteName}`"
  >
    VS
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { IMatch } from "~src/interfaces";
import MatchEnum from "~src/enums/MatchEnum";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface IProps {
  match: IMatch;
  size?: number;
  modifyClass?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  size: 42,
});

const siteName = computed(() => commonStore.getSiteName);

const isShowScore = computed(() => {
  return [...MatchEnum.LIST_STATUS_PLAYING, MatchEnum.STATUS_END].includes(
    props.match.status_id
  );
});

const homeScore = computed(() => {
  let score = props.match.home_scores[0];

  // Trường hợp đá hiệp phụ
  if (props.match.home_scores[5] > 0) {
    score = props.match.home_scores[5];

    return score;
  }

  return score;
});

const awayScore = computed(() => {
  let score = props.match.away_scores[0];

  // Trường hợp đá hiệp phụ
  if (props.match.away_scores[5] > 0) {
    score = props.match.away_scores[5];

    return score;
  }

  return score;
});
</script>

<script lang="ts">
export default {};
</script>
